import type { JSX, ReactNode } from 'react';

export const PRIVACY_LAST_UPDATED = '3 November 2026';
export const PRIVACY_CONTACT_EMAIL = 'privacy@careerverification.com';

export function Section({ title, children }: { title: string; children: ReactNode }): JSX.Element {
  return (
    <section className="space-y-2">
      <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
      {children}
    </section>
  );
}

export function ContactEmailLink(): JSX.Element {
  return (
    <a
      className="text-primary underline underline-offset-4"
      href={`mailto:${PRIVACY_CONTACT_EMAIL}`}
    >
      {PRIVACY_CONTACT_EMAIL}
    </a>
  );
}

interface DataTableProps {
  caption: string;
  headers: readonly [string, string, string];
  rows: readonly (readonly [string, string, string])[];
}

export function DataTable({ caption, headers, rows }: DataTableProps): JSX.Element {
  return (
    <div className="mt-2 overflow-x-auto">
      <table className="w-full border-collapse text-left text-sm">
        <caption className="sr-only">{caption}</caption>
        <thead>
          <tr className="border-b">
            {headers.map((header) => (
              <th className="py-2 pr-4 font-semibold last:pr-0" key={header} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr className="border-b last:border-0" key={row[0]}>
              {row.map((cell, index) => (
                <td className="py-2 pr-4 last:pr-0" key={`${row[0]}-${index}`}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
